module.exports = __webpack_public_path__ + "img/helical_left_gear.prt.73c3995e.jpg";